import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const bonuses = [{
  tag: '🎁 Bonus n. 1',
  emoji: '🎥',
  title: 'PACCHETTO ARCADE DI CARTONE',
  text: 'Una divertente raccolta di video che mostra passo dopo passo come costruire giochi interattivi come un mini tavolo spaceball, ruote della fortuna personalizzate e macchine arcade usando semplice cartone e tanta immaginazione.',
  img: 'https://cdn.magicpatterns.com/uploads/kX7zgPdQHdv9BM33ASEWE4/ChatGPT_Image_3_oct_2026,_03_36_04_p.m..png',
  price: '$25,00',
  tone: 'bg-sky-light',
  tagTone: 'bg-sky/20 text-sky'
}, {
  tag: '🎁 Bonus n. 2',
  emoji: '✂️',
  title: 'LA GUIDA AI LAVORETTI DI CARTA IN 5 MINUTI',
  text: 'Il tuo manuale di riferimento per lavoretti rapidi e puliti con carta e cartone. Perfetto per i pomeriggi in cui non hai materiali speciali ma vuoi un’attività semplice per allontanarli dagli schermi.',
  img: 'https://cdn.magicpatterns.com/uploads/ox4zMfSaqmdC46AQPS3naR/Gemini_Generated_Image_it96giit96giit96.jpg',
  price: '$19,00',
  tone: 'bg-sunshine-light',
  tagTone: 'bg-sunshine/30 text-ink'
}, {
  tag: '🎁 Bonus n. 3',
  emoji: '🌈',
  title: 'PICCOLI CREATORI: SLIME E GIOCHI SENSORIALI',
  text: 'Una guida specializzata ricca di ricette facili per slime fatti in casa, pasta da modellare e texture sensoriali. Ideale per tenere felicemente occupati i fratellini più piccoli mentre creano con le proprie mani.',
  img: 'https://cdn.magicpatterns.com/uploads/gcB21rUC8nAv8ifHwxG25W/Gemini_Generated_Image_xwhsejxwhsejxwhs.jpg',
  price: '$19,00',
  tone: 'bg-coral-light',
  tagTone: 'bg-coral/20 text-coral'
}];
export function Bonuses() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-23" data-mp="npi3eb9zxus4">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-24" data-mp="ns4c4e8migbx">
        <SectionHeading eyebrow="🎁 Bonus esclusivi" title={<>Ordina oggi e ricevi questi 3 bonus gratuiti</>} subtitle="Ottieni MakerLab oggi e sbloccherai anche questi 3 bonus esclusivi — tuoi per sempre, senza costi aggiuntivi." data-id="element-25" data-mp="irq42w70v6dw" />
        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-26" data-mp="3ljum8ihh6gpl">
          {bonuses.map((b, i) => <motion.article key={b.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`flex flex-col overflow-hidden rounded-3xl border border-ink/10 ${b.tone}`} data-id="element-27" data-mp="3qiph4ispvvq2" data-mpi={i}>
              <div className="aspect-square w-full overflow-hidden border-b border-ink/10" data-id="element-28" data-mp="2a2d355r8ifv1">
                <img src={b.img} alt={b.title} className="h-full w-full object-cover" data-id="element-29" data-mp="2f1pqdrm0poy5" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-30" data-mp="22m828m387z2g">
                <div className="mb-3 flex items-center justify-between" data-id="element-31" data-mp="1xlk47ggkyhyq">
                  <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide ${b.tagTone}`} data-id="element-32" data-mp="1xnwqu6xa9gi4">
                    <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-33" data-mp="1om73bc6iv1pm" />
                    {b.tag}
                  </span>
                  <span className="flex items-center gap-1.5 text-sm" data-id="element-34" data-mp="1jsud4xm72mur">
                    <span className="text-ink/40 line-through" data-id="element-35" data-mp="1ewdtafm12unh">{b.price}</span>
                    <span className="font-bold text-emerald-600" data-id="element-36" data-mp="19wrei1qjx6ck">GRATIS</span>
                  </span>
                </div>
                <h3 className="font-display text-lg font-bold leading-snug text-ink" data-id="element-37" data-mp="15tmec5ty1gr3">
                  {b.emoji} {b.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-38" data-mp="10xxb9sipthq1">
                  {b.text}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}